import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { tsmMessageLoader } from './tsm/tsmMessageLoader';
import { isTSMEnabled } from './tsm/tsmHelpers';
var messagesLoaderPropTypes = {
  language: PropTypes.string.isRequired,
  messageLoader: PropTypes.func.isRequired,
  coreMessageLoader: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired
};
export var MessagesLoader = function MessagesLoader(_ref) {
  var language = _ref.language,
      messageLoader = _ref.messageLoader,
      coreMessageLoader = _ref.coreMessageLoader,
      onLoad = _ref.onLoad;
  useEffect(function () {
    var hasLanguageChanged = false;

    var load = function load() {
      var _context, promises, messages;

      return _regeneratorRuntime.async(function load$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              promises = [coreMessageLoader(language), messageLoader(language)];

              if (isTSMEnabled()) {
                promises.push(tsmMessageLoader(language));
              }

              _context2.t0 = _reduceInstanceProperty;
              _context2.next = 5;
              return _regeneratorRuntime.awrap(_Promise.all(promises));

            case 5:
              _context2.t1 = _context = _context2.sent;
              messages = (0, _context2.t0)(_context2.t1).call(_context, function (acc, next) {
                return _Object$assign(acc, next);
              }, {});

              if (!hasLanguageChanged) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return");

            case 9:
              onLoad(messages);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, null, null, null, Promise);
    };

    load();
    return function () {
      hasLanguageChanged = true;
    };
  }, [language, messageLoader, coreMessageLoader, onLoad]);
  return null;
};
MessagesLoader.propTypes = messagesLoaderPropTypes;
MessagesLoader.displayName = 'MessagesLoader';